import { Action, createReducer, on } from '@ngrx/store';
import * as Actions from './quick-quote.actions';
import cloneDeep from 'clone-deep';

export interface State {
  quickQuote: any;
}

export const featureKey = 'flowDataQuickQuote';

export const initialState: State = {
  quickQuote: null,
};

export function quickQuoteReducer(state: State | undefined, action: Action): State {
  return createReducer(
    initialState,
    on(Actions.ResetQuickQuote, (state, {}) => ({
      ...state,
      quickQuote: null,
    })),
    on(Actions.UpdateQuickQuote, (state, { data }) => ({
      ...state,
      quickQuote: cloneDeep(data),
    }))
  )(state, action);
}
